export default __webpack_public_path__ + "static/media/aboutUs-rcs@2x.b35056ea.png";